import type { SlotChildAlignment, SlotTypes } from "./types";

type GetSlotChildPositionBySlotTypeArgs = {
    slotType: SlotTypes;
};

type GetSlotChildPositionBySlotTypeResult = {
    verticalAlignment: SlotChildAlignment;
    horizontalAlignment: SlotChildAlignment;
};

/**
 * Определяет выравнивание children слота по вертикали и горизонтали в зависимости от типа слота.
 * @param slotType - тип слота, определяющий выравнивание его children.
 * @returns объект с вертикальным и горизонтальным выравниванием children слота.
 */
export const getSlotChildPositionBySlotType = ({
    slotType,
}: GetSlotChildPositionBySlotTypeArgs): GetSlotChildPositionBySlotTypeResult => {
    switch (slotType) {
        case "SlotBottom":
            return {
                verticalAlignment: "end",
                horizontalAlignment: "center",
            };
        case "SlotBottomLeft":
            return { verticalAlignment: "end", horizontalAlignment: "start" };
        case "SlotBottomRight":
            return {
                verticalAlignment: "end",
                horizontalAlignment: "end",
            };
        case "SlotMiddle":
            return {
                verticalAlignment: "center",
                horizontalAlignment: "center",
            };
        case "SlotLeft":
            return {
                verticalAlignment: "center",
                horizontalAlignment: "start",
            };
        case "SlotRight":
            return {
                verticalAlignment: "center",
                horizontalAlignment: "end",
            };
        case "SlotTop":
            return {
                verticalAlignment: "start",
                horizontalAlignment: "center",
            };
        case "SlotTopLeft":
            return { verticalAlignment: "start", horizontalAlignment: "start" };
        case "SlotTopRight":
            return { verticalAlignment: "start", horizontalAlignment: "end" };
        default:
            return {
                verticalAlignment: "center",
                horizontalAlignment: "center",
            };
    }
};
